import { ModuleFE_DiseaseProfile } from './ModuleFE_DiseaseProfile.js';
export const ModulePackFE_DiseaseProfileDB = [ModuleFE_DiseaseProfile];
//# sourceMappingURL=module-pack.js.map